import { render, staticRenderFns } from "./ComparePage.vue?vue&type=template&id=f474b25e&scoped=true&"
import script from "./ComparePage.vue?vue&type=script&lang=js&"
export * from "./ComparePage.vue?vue&type=script&lang=js&"
import style0 from "./ComparePage.vue?vue&type=style&index=0&id=f474b25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f474b25e",
  null
  
)

export default component.exports